export default __webpack_public_path__ + "static/media/img_01.59379fbf.jpg";